import "./style.scss";

import { StyledMenuItem, StyledSelect } from "components/shared/StyledSelect";
import { t } from "i18next";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { fetchCreateEntry } from "store/accountingStore";
import { useAppDispatch } from "store/store";
import type { AccountingEntry } from "store/types";

import type { AccountingFilterOptions, AccountingTypologyFilter } from "./useAccountingFilters";

interface IAddFilter {
    close: (success: boolean) => void;
    entry: AccountingEntry;
    filters: AccountingTypologyFilter[];
    filterOptions: AccountingFilterOptions;
}

const AddFilter = ({ close, entry, filters, filterOptions }: IAddFilter) => {
    const [t] = useTranslation();
    const dispatch = useAppDispatch();

    const [filter, setFilter] = useState<string>("none");
    const [filterOption, setFilterOption] = useState<string>("none");

    const handleSubmit = () => {
        if (filter === "none" || filterOption === "none") return;
        dispatch(
            fetchCreateEntry({
                ...entry,
                filters: {
                    ...entry.filters,
                    typology: entry.name,
                    [filter]: filterOption,
                },
            }),
        ).then((resp) => {
            if (resp.meta.requestStatus === "fulfilled") {
                if (resp.meta.requestStatus === "fulfilled") {
                    const element = document.getElementById(`typology-${(resp.payload as any).data.id}`);
                    element?.scrollIntoView({ behavior: "smooth" });
                }
            }
        });
        close(true);
    };

    return (
        <div className="typology-modal-wrapper">
            <h3 style={{ marginBottom: "0" }}>{t("Accounting.Filters.FilterInfo1")}</h3>
            <h3>{t("Accounting.Filters.FilterInfo2")}</h3>
            <div className="filter-form">
                <StyledSelect
                    size="small"
                    name="filter"
                    value={filter}
                    onChange={(e: any) => setFilter(e.target.value)}
                >
                    <StyledMenuItem value="none">{t("Accounting.Filters.ChooseFilter")}</StyledMenuItem>
                    {filters.map((filter) => {
                        return (
                            <StyledMenuItem value={filter.key} key={filter.id}>
                                {t(filter.description)}
                            </StyledMenuItem>
                        );
                    })}
                </StyledSelect>
                {filter !== "none" && (
                    <StyledSelect
                        size="small"
                        name="filterOption"
                        value={filterOption}
                        onChange={(e: any) => setFilterOption(e.target.value)}
                    >
                        <StyledMenuItem value="none">{t("Accounting.Filters.ChooseOption")}</StyledMenuItem>
                        {filterOptions[filter]?.map((option) => {
                            return (
                                <StyledMenuItem value={option.key} key={option.id}>
                                    {t(option.description)}
                                </StyledMenuItem>
                            );
                        })}
                    </StyledSelect>
                )}
                <div className="duplicate-modal-btn">
                    <button className="btn-cancel" onClick={() => close(true)}>
                        {t("Accounting.Cancel")}
                    </button>
                    <button className="btn-validate" onClick={handleSubmit}>
                        {t("Accounting.Validate")}
                    </button>
                </div>
            </div>
        </div>
    );
};

export { AddFilter };
